






































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import { HsabExpenseResponse, HsabExpenseReimbursementResponse } from "@/shared/types";
import moment from "moment/moment";
import { formatCurrency } from "@/shared/currency.js";
import HsabExpenseReimbursementDenialReason from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseReimbursementDenialReason.vue";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";

@Component({
  components: { HsabExpenseReimbursementDenialReason }
})
export default class HsabExpenseCardRowPaymentDetail extends Vue {
  formatCurrency = formatCurrency;

  @Prop()
  expense: HsabExpenseResponse;

  @Prop({ default: false })
  ExpenseHasAnyOverflow: boolean;

  @Prop()
  reimbursement: HsabExpenseReimbursementResponse;

  get hasReimbursement () {
    return !isNullEmptyOrUndefined(this.reimbursement);
  }

  get hasDenialReasons (): boolean {
    const hasDenials = this.reimbursement
        && this.reimbursement.denialReasons
        && this.reimbursement.denialReasons.length > 0;
    return hasDenials;
  }

  get isNotionalReimbursement () {
    return this.reimbursement
        && this.reimbursement.externalReimbursementId;
  }

  get isHsaReimbursement () {
    return this.reimbursement
        && this.reimbursement.planName === "Health Savings Account";
  }

  get paidAmountOrZero (): number {
    if (this.reimbursement && this.reimbursement.paidAmount) {
      return this.reimbursement.paidAmount;
    }
    return 0;
  }

  get approvedAmountOrZero (): number {
    if (this.reimbursement && this.reimbursement.approvedAmount) {
      return this.reimbursement.approvedAmount;
    }
    return 0;
  }

  get formattedFinalFilingDate () {
    if (this.reimbursement && this.reimbursement.planYearFinalFilingDate) {
      return moment(this.reimbursement.planYearFinalFilingDate).format("MMM DD, YYYY");
    }
    return "";
  }

  get formattedScheduledForReimbursementDate () {
    if (this.reimbursement && this.reimbursement.scheduledForReimbursementDate) {
      return moment(this.reimbursement.scheduledForReimbursementDate).format("MMM DD, YYYY");
    }
    return "";
  }

  get showScheduledReimbursementDate () {
    return this.reimbursement && !isNullEmptyOrUndefined(this.reimbursement.scheduledForReimbursementDate);
  }

  get showApprovedAmount () {
    return this.reimbursement && !isNullEmptyOrUndefined(this.reimbursement.approvedAmount);
  }

  get showPlanName () {
    return this.reimbursement && !isNullEmptyOrUndefined(this.reimbursement.planName);
  }

  get showPlanYearName () {
    return this.reimbursement && !isNullEmptyOrUndefined(this.reimbursement.planYearName);
  }

  get showPlanYearFinalFilingDate () {
    return this.reimbursement && !isNullEmptyOrUndefined(this.reimbursement.planYearFinalFilingDate);
  }

  get showPaidAmount () {
    return !isNullEmptyOrUndefined(this.paidAmountOrZero);
  }
}
